$shm_hitalama_map_book_tools_float $mol_view
	Map_page $shm_hitalama_map_page
	tool_mode? \
	draggers_suppressed? false
	pointer_pos? /number
	drag_side? \
	attr *
		^
		dragger_side <= dragger_side \
	style *
		^
		left <= left \0px
		top <= top \0px
		maxHeight <= max_height \100vh
	sub /
		<= Tools $shm_hitalama_map_book_tools_float_quick
			tool_mode? <=> tool_mode?
			draggers_suppressed? <=> draggers_suppressed?
			vertical <= vertical false
			style *
				^
				maxHeight <= max_height
		<= Dragger_left $mol_button_minor
			hint \Переместить инструменты
			sub /
				<= Drag_left_icon_1 $mol_icon_dots_vertical
				<= Drag_left_icon_2 $mol_icon_dots_vertical
			event *
				^
				pointerdown? <=> drag_left_start? null
		<= Dragger_right $mol_button_minor
			hint \Переместить инструменты
			sub /
				<= Drag_right_icon_1 $mol_icon_dots_vertical
				<= Drag_right_icon_2 $mol_icon_dots_vertical
			event *
				^
				pointerdown? <=> drag_right_start? null
	Drag $rise_drag
		x? <=> x? 0
		y? <=> y? 0
$shm_hitalama_map_book_tools_float_quick $shm_hitalama_quick2_reorder
	tool_mode? \
	draggers_suppressed? false
	available_ids /
		\select
		\drawing
		\rect
		\circle
		\text
		\text_md
	Select_icon $mol_icon_cursor_default
	Drawing_icon $mol_icon_pencil
	Rect_icon $mol_icon_rectangle_outline
	Circle_icon $mol_icon_circle_outline
	Text_icon $mol_icon_format_text
	Markdown_icon $mol_icon_language_markdown_outline
